// 平台 sellChannel 匹配
// key 值 与 appName 保持一致 且 在 platform 中 添加同名配置文件

// 采用gulp task 自动读取模式
export default {
  dianping: 1,
  // 点评APP
  meituan: 2,
  // 美团APP
  dianping_chwl: 3,
  // 点评吃喝玩乐
  wxapp_wallet: 7,
  // 猫眼微信演出小程序
  maoyan: 5,
  // 猫眼APP
  maoyan_wechat: 6,
  // 猫眼微信H5
  wxapp_show: 4,
  // 猫眼演出小程序
  gewara: 8,
  // 格瓦拉
  dianping_wxapp: 12,
  // 点评小程序
  qqwallet: 13,
  // QQ钱包-演出
  wxapp_smartvenue: 17,
  // 智慧场馆小程序
  wxapp_activeapp: 19,
  // 主办自销小程序
  cmb_app: 28 // 招商银行app
};